import React from "react";
import styled from "styled-components";
import { Outlet, useLocation } from "react-router";
import Header from "../Header";
import CommunicationBanner from "../CommunicationBanner";
import { useStores } from "../../context/storesContext";

const Layout = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: ${(props) => props?.theme?.colors?.greyBase};
  z-index: 999999;
`;

const Main = styled.main<{ pad: number }>`
  padding: ${(props) => `${props?.pad}px`};
  z-index: 1;
`;

function RootLayout() {
  const { selectedStore } = useStores();
  const router = useLocation();
  return (
    <Layout>
      <Header />
        {selectedStore?.countryKey === 'FRA' && <CommunicationBanner />}
        <Main pad={router?.pathname?.includes("region") ? 0 : 16}>
        <Outlet />
      </Main>
    </Layout>
  );
}

export default RootLayout;
